import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  width: 100%;
  padding: 1.2rem 2rem;
  background: #222;
  color: #fff;
  text-align: center;
  font-size: 1rem;
  letter-spacing: 1px;
  margin-top: auto;

  @media (max-width: 600px) {
    padding: 1rem;
    font-size: 0.95rem;
  }
`;

import { useTranslation } from 'react-i18next';
import { ReactComponent as InstagramIcon } from '../assets/socials/instagram.svg';
import { ReactComponent as FacebookIcon } from '../assets/socials/facebook.svg';
import { ReactComponent as WhatsAppIcon } from '../assets/socials/whatsapp.svg';
import { ReactComponent as ViberIcon } from '../assets/socials/viber.svg';

const FooterInfo = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 2.5rem;
  margin-bottom: 0.7rem;
  @media (max-width: 700px) {
    flex-direction: column;
    align-items: center;
    gap: 1.2rem;
  }
`;
const FooterSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  font-size: 1.1rem;
`;
const SocialIcons = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
`;

const Footer = () => {
  const { t } = useTranslation();
  return (
    <FooterContainer>
      <FooterInfo>
        <FooterSection>
          <div>📞 {t('footer.phone')}</div>
          <div style={{ opacity: 0.7, fontSize: '0.97em' }}>{t('footer.phoneNumber2')}</div>
          <div style={{ opacity: 0.7, fontSize: '0.97em' }}>{t('footer.phoneNumber')}</div>
          <div style={{ marginTop: '0.6em' }}>✉️ {t('footer.email')}</div>
          <div style={{ opacity: 0.7, fontSize: '0.97em', marginTop: '0.2em' }}>
            <a href={`mailto:${t('footer.emailAddress')}`} style={{ color: '#fff', textDecoration: 'underline', wordBreak: 'break-all' }}>{t('footer.emailAddress')}</a>
          </div>
        </FooterSection>
        <FooterSection>
          <div>📍 {t('footer.location')}</div>
          <div style={{ opacity: 0.7, fontSize: '0.97em' }}>
            <a
              href="https://www.google.com/maps?q=38.059313406881365,23.611259510064063"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#fff', textDecoration: 'underline', wordBreak: 'break-word' }}
            >
              {t('footer.locationAddress')}<br />{t('footer.locationAddress2')}
            </a>
          </div>
        </FooterSection>
        <FooterSection>
          <div>{t('footer.follow')}</div>
          <SocialIcons>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <InstagramIcon style={{ width: 28, height: 28 }} />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer">
              <FacebookIcon style={{ width: 28, height: 28 }} />
            </a>
            <a href="https://wa.me/306943189050" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
              <WhatsAppIcon style={{ width: 28, height: 28 }} />
            </a>
            <a href="viber://chat?number=306943189050" target="_blank" rel="noopener noreferrer" aria-label="Viber">
              <ViberIcon style={{ width: 28, height: 28 }} />
            </a>
          </SocialIcons>
        </FooterSection>
      </FooterInfo>
      &copy; {new Date().getFullYear()} <a href="https://www.instagram.com/rankos.clo/" 
      target="_blank" 
      rel="noopener noreferrer" 
      style={{
        color: 'white',
        cursor: 'pointer'
      }}>{t('brand.name')}</a>
      &nbsp; {t('footer.rights')}
    </FooterContainer>
  );
};

export default Footer;
